import data from "./data";
import RezerwyTable from "./table";
const Rezerwy = () => {
    return (
      <>
        <RezerwyTable></RezerwyTable>
      </>
    );
  };
  export default Rezerwy;